import styled from 'styled-components';

export const DrawerContents = styled.div`
  padding: var(--wb-drawer-top-padding) 0 0 0;
  height: 100%;
`;
DrawerContents.displayName = 'S.DrawerContents';
